"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
Object.defineProperty(exports, "__esModule", {
  value: true
});
var BaseModel_1 = require("./BaseModel");
var Release_1 = require("./Release");
var Change_1 = require("./Change");
var Commit_1 = require("./Commit");
/** Class representing an user. */
var Project = /** @class */function (_super) {
  __extends(Project, _super);
  function Project(properties) {
    var _this = _super.call(this, {}) || this;
    _this._id = properties._id;
    _this.name = properties.name;
    _this.active = properties.active;
    _this.repository = properties.repository || {};
    _this.repository.branch = _this.repository.branch || 'master';
    _this.commitRules = properties.commitRules;
    _this.tagRules = properties.tagRules;
    _this.description = properties.description;
    _this.comments = properties.comments;
    _this.roadmap = properties.roadmap;
    // virtuals
    _this.nbReleases = properties.nbReleases || 0;
    _this.releases = (properties.releases || []).map(function (r) {
      return new Release_1.default(r);
    });
    _this.nbCommits = properties.nbCommits || 0;
    _this.commits = (properties.commits || []).map(function (c) {
      return new Commit_1.default(c);
    });
    _this.changes = (properties.changes || []).map(function (c) {
      return new Change_1.default(c);
    });
    return _this;
  }
  Project.prototype.lastRelease = function () {
    var _a;
    if (!((_a = this.releases) === null || _a === void 0 ? void 0 : _a.length)) return null;
    return (this.releases || []).sort(function (a, b) {
      if (a.date.isBefore(b.date)) return 1;
      return a.date.isAfter(b.date) ? -1 : 0;
    })[0];
  };
  Project.prototype.sortedCommits = function () {
    return (this.commits || []).sort(function (a, b) {
      if (a.date.isBefore(b.date)) return 1;
      return a.date.isAfter(b.date) ? -1 : 0;
    });
  };
  Project.prototype.sortedReleases = function () {
    return (this.releases || []).sort(function (a, b) {
      if (a.date.isBefore(b.date)) return 1;
      return a.date.isAfter(b.date) ? -1 : 0;
    });
  };
  Project.prototype.getInitials = function () {
    var _a, _b, _c;
    if (!this.name) return '??';
    return (_c = (_b = (_a = this.name.match(/(\b\S)?/g)) === null || _a === void 0 ? void 0 : _a.join("")) === null || _b === void 0 ? void 0 : _b.match(/(^\S|\S$)?/g)) === null || _c === void 0 ? void 0 : _c.join("");
  };
  return Project;
}(BaseModel_1.default);
exports.default = Project;